import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const losingDataIcon = css`
  color: ${colors.error.hover};
  margin-right: 10px;
`;

export const nonAssociatedIcon = css`
  color: ${colors.gray.dark};
  margin-right: 10px;
`;

export const associatedIcon = css`
  color: ${colors.accessory._5};
  margin-right: 10px;
`;
